<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';

	import woodenArchedWindowWithTagImg from './images/LP-Limited-Commercial-Warranty-01.jpg';
	import commercialAdImage from './images/LP-Limited-Commercial-Warranty-02.jpg';
</script>

<Section backgroundColor="blue" backgroundImage={woodenArchedWindowWithTagImg}>
	<h1>Limited Commercial Warranty</h1>
</Section>

<Section
	class="
   max-md:[&_h3]:w-full max-md:[&_h3]:text-left
   [&_p]:text-left
 "
>
	<p>
		R Value, Inc. doing business as Indow (“Indow”) warrants its window inserts,
		not otherwise covered by its Limited Residential Warranty, against defects
		of materials or workmanship for ten (10) years from the date of purchase.
		Click <a
			target="_blank"
			href="/static/pdfs/IW-Care-Guide-Limited-Warranty_05-01-14.pdf">here</a
		> to view Indow warranty information for purchases prior to 1/1/15.
	</p>
	<h2 class="text-left text-lg uppercase">Exclusions</h2>
	<p>
		This warranty does not apply to any Indow window insert which has been
		subject to accident, acts of God, fire, flood, abuse or misuse, abuse by
		harmful fumes, vapors, solvents, chemicals or chemical pollutants in the
		atmosphere, mold, building settlement or structural failures of walls or
		foundations. We do not warrant our glazing against scratching or breakage
		which can occur if improperly handled. We do not warrant our acrylic glazing
		against clouding, yellowing or loss of light transmission caused by dirt,
		scratching, breakage, or improper cleaning with ammonia or bleach based
		cleaners.
	</p>

	<h2 class="text-left text-lg uppercase">Glazing and Tubing</h2>
	<p>
		Indow uses only the highest quality materials in the manufacture of our
		products. Indow warrants its clear acrylic glazing against a change in light
		transmission in excess of 3%. This does not cover certain specialty grades
		that are not clear to start with (including Blackout, Sleep Panels, Privacy
		and Shade Grades), nor clear acrylic glazing exposed to artificial light
		sources emitting intense amounts of UVB or higher energy radiation. The
		Indow compression tubing is made of silicone which resists the effects of
		heat, cold and ultraviolet exposure.
	</p>

	<h2 class="text-left text-lg uppercase">Condensation</h2>
	<p>
		Condensation is not a product defect, but the result of excess humidity.
		Condensation, frost, or mold, mildew, or fungus on window surfaces is not
		covered by the Limited Warranty. Indow bears no responsibility or liability
		for any situation where molds or other associated conditions arise as a
		result of improper use, cleaning, sealing, humidification or ventilation.
	</p>

	<h2 class="text-left text-lg uppercase">Venting</h2>
	<p>
		Indow does not warrant its window inserts against venting excess air
		pressure. It is part of an Indow window insert’s normal function to
		occasionally relieve excess air pressure by ‘popping’ a corner or side in
		response to heavy external winds combined with extreme temperatures or a
		blower door test. Simply press the window insert back into place to restore
		normal function.
	</p>

	<h2 class="text-left text-lg uppercase">Window Opening Control Devices</h2>
	<p>
		Window Opening Control Devices (WOCDs) are not a substitute for careful
		supervision of children. WOCDs must be tested at least monthly. Follow all
		safety information and instructions provided with WOCDs.
	</p>
	<p>
		Indow will not pay for any incidental or consequential damages, and its
		liability under this warranty, or under any implied warranty, is limited to
		repairing or replacing (in its sole discretion) any part or parts of the
		window insert that are found to be defective under the terms of this
		warranty. We will endeavor to supply original replacement parts; however,
		replacement parts may differ from the original parts. Warranty repair or
		replacement of the Indow window insert is free of charge to you. In the case
		of improper cleaning, storage or maintenance, Indow will not be held
		responsible for any costs incurred in repairing or replacing any product
		under this warranty including, but not limited to, transportation costs,
		costs of removal, disposal, installation or reinstallation.
	</p>
	<p>
		Approved care, cleaning, and installation instructions are available
		<a href="/about-indow/care">here</a>.
	</p>

	<h2 class="text-left text-lg uppercase">TO MAKE A CLAIM</h2>
	<p>
		If you discover a defect of materials or workmanship, please contact Indow.
		Upon providing proof of purchase (Indow in its sole discretion) will repair
		or replace your defective Indow window insert(s) or its components. This
		limited warranty is effective for products purchased on or after October 31,
		2021.
	</p>
</Section>
<Parallax image={commercialAdImage} />
